const SET_PROPERTY = 'SET_PROPERTY_FOR_APP';
const SET_UP_SIGNALR = 'SET_UP_SIGNALR';

const OPEN_SNACK = 'DISPLAY_SNACK';
const CLOSE_SNACK = 'HIDE_SNACK';

const OPEN_AUTH_DIALOG = 'OPEN_AUTH_DIALOG';
const CLOSE_AUTH_DIALOG = 'CLOSE_AUTH_DIALOG';
const SET_AUTH_DIALOG_FORM_TYPE = 'SET_AUTH_DIALOG_FORM_TYPE';
const START_AUTH_DIALOG_REQUEST = 'START_AUTH_DIALOG_REQUEST';
const STOP_AUTH_DIALOG_REQUEST = 'STOP_AUTH_DIALOG_REQUEST';
const COMPLETE_LOGIN = 'COMPLETE_LOGIN';
const COMPLETE_SIGN_UP = 'COMPLETE_SIGN_UP';
const COMPLETE_PASSWORD_RECOVER_REQUEST = 'COMPLETE_PASSWORD_RECOVER_REQUEST';

const SET_REFRESH_METHOD = 'SET_REFRESH_METHOD';

const SET_ACCOUNT_DETAILS = 'SET_ACCOUNT_DETAILS';
const SET_GETTING_ACCOUNT_DETAILS = 'SET_GETTING_ACCOUNT_DETAILS';
const SHOW_INFORMATION_DIALOG = 'SHOW_INFORMATION_DIALOG'; 

export default {
    SET_UP_SIGNALR,
    OPEN_SNACK,
    CLOSE_SNACK,
    OPEN_AUTH_DIALOG,
    CLOSE_AUTH_DIALOG,
    SET_AUTH_DIALOG_FORM_TYPE,
    START_AUTH_DIALOG_REQUEST,
    STOP_AUTH_DIALOG_REQUEST,
    COMPLETE_LOGIN,
    COMPLETE_SIGN_UP,
    COMPLETE_PASSWORD_RECOVER_REQUEST,
    SET_REFRESH_METHOD,
    SET_ACCOUNT_DETAILS,
    SET_GETTING_ACCOUNT_DETAILS,
    SET_PROPERTY,
    SHOW_INFORMATION_DIALOG
}